import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, BadgeButton } from "catalyst/badge";
import { Heading } from "catalyst/heading";
import { Text, TextLink } from "catalyst/text";
import { useState } from "react";
import { apiIssueSupportCode } from "../lib/api.js";
import { emailErrorMessage } from "../lib/email.js";
const Support = ({ build }) => {
    const [supportCode, setSupportCode] = useState(null);
    const [isRequesting, setIsRequesting] = useState(false);
    const [error, setError] = useState(null);
    const issueSupportCode = async () => {
        if (isRequesting || supportCode)
            return;
        setIsRequesting(true);
        setError(null);
        try {
            const data = await apiIssueSupportCode();
            if (typeof data?.support_code !== "string" || !data.support_code.trim()) {
                setError("Не удалось получить код. Попробуйте еще раз.");
                return;
            }
            setSupportCode(data.support_code);
        }
        catch (reason) {
            setError(emailErrorMessage(reason));
        }
        finally {
            setIsRequesting(false);
        }
    };
    return (_jsxs("div", { className: "max-w-lg", children: [_jsx(Heading, { className: "mb-6", children: "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430" }), _jsxs(Text, { className: "mb-6", children: ["\u0421\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043D\u0430\u043C\u0438 \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435", " ", _jsx(TextLink, { href: "mailto:support@coreinfra.ai", children: "support@coreinfra.ai" }), " ", "\u2013 \u0438\u043B\u0438 \u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043D\u0430\u043C \u043B\u0438\u0447\u043D\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0432 \u043A\u0430\u043D\u0430\u043B\u0435", " ", _jsx(TextLink, { href: "https://t.me/coreinfra", children: "@coreinfra" }), "."] }), _jsxs(Text, { children: ["\u0421\u043E\u043E\u0431\u0449\u0438\u0442\u0435 \u044D\u0442\u043E\u0442 \u043A\u043E\u0434 \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0438:", " ", supportCode ? (_jsx(Badge, { children: _jsx("code", { children: supportCode }) })) : (_jsx(BadgeButton, { disabled: isRequesting, onClick: issueSupportCode, children: isRequesting ? "Запрашиваем..." : "Получить код" }))] }), error && (_jsx(Text, { role: "alert", className: "mt-4 text-red-600! dark:text-red-500!", children: error })), _jsxs(Text, { className: "mt-6", children: ["\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F:", " ", _jsx(Badge, { children: _jsx("code", { className: "select-text", children: build }) })] })] }));
};
export default Support;
